<template>
  <section>
    <form class="columns local-lm-filters-columns">
      <div class="column is-2">
        <order-bo-filter />
      </div>
      <div class="column is-3">
        <mov-states-filter
          multiple
          @input="doMovStatesFilterCLicked"
        />
      </div>
      <div
        class="column is-3"
      >
        <b-field>
          <b-datepicker
            :placeholder="$t('Filters.labelFilterPyxisCreation')"
            icon="clock-start"
            v-model="orderPyxisDates[0]"
            class="local-lm-filters-datepicker"
            @click.native="activeFilterOrderPyxis"
            :disabled="hasOpenFilterOrderPyxis"
            range
          />
        </b-field>
      </div>
      <div
        class="column is-3"
      >
        <b-field>
          <b-datepicker
            :placeholder="$t('Filters.labelFilterDisponibility')"
            icon="playlist-check"
            v-model="disponibilityDates[0]"
            class="local-lm-filters-datepicker"
            @click.native="activeFilterDisponibility"
            :disabled="hasOpenFilterDisponibility"
            range
          />
        </b-field>
      </div>
      <div class="column is-1 local-lm-limit-width">
        <b-button
          class="lm-default-btn-outline-green--without-width lm-default-btn-delete"
          icon-right="close"
          size="is-small"
          @click.prevent="cleanFilters"
        />
        <b-button
          class="lm-default-btn-outline-green--without-width"
          icon-right="magnify"
          size="is-small"
          @click.prevent="submitData"
        />
      </div>
    </form>
  </section>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { mixin } from '@/mixins'

import OrderBoFilter from '@/components/filters/OrderBoFilter'
import MovStatesFilter from '@/components/filters/MovStatesFilter'

export default {
  name: 'OrderFilters',
  components: {
    OrderBoFilter,
    MovStatesFilter
  },
  mixins: [
    mixin.notifications,
    mixin.dates
  ],
  data () {
    return {
      orderPyxisDates: [],
      disponibilityDates: [],
      hasOpenFilterOrderPyxis: false,
      hasOpenFilterDisponibility: false
    }
  },
  computed: {
    ...mapGetters('filters', ['filtersSelected']),
    ...mapGetters('orders', ['totalCount'])
  },
  mounted () {
    this.$eventBus.$on('getOrders', async () => {
      this._getOrders()
    })

    this.$eventBus.$on('closeModal', async () => {
      this._getOrders()
    })

    this.$eventBus.$on('onPageChange', async (page) => {
      this._getOrders()
    })

    this.$eventBus.$on('writeOrder', this.disableBothFilters)
    this._getOrders()
  },
  methods: {
    ...mapActions('filters', [
      'setMovStatesSelected',
      'resetPage',
      'setPyxisDateSelected',
      'setDisponibilityDateSelected'
    ]),
    ...mapActions('orders', ['getOrders']),
    async _getOrders (sort = null) {
      const filters = await this.filtersSelected
      if (sort) filters.sort = sort

      const payload = { filters }
      const orders = await this.getOrders(payload)
      if (!orders.level) return this.wrong(this.$t(orders.errorText))

      if (orders && this.totalCount === 0) this.$eventBus.$emit('emptyOrders')
      if (orders && this.totalCount) this.$eventBus.$emit('orders')
    },
    async submitData () {
      const filters = await this.filtersSelected
      if (!filters.supplierOrderCode &&
        !filters.movStateOption &&
        !this.orderPyxisDates.length &&
        !this.disponibilityDates.length
      ) {
        return this.wrong(this.$t('Errors.someFiltersNeeded'))
      }

      this.resetPage()

      if (this.orderPyxisDates.length) {
        const flattenedArray = [].concat(...this.orderPyxisDates)
        const dates = {
          pyxisDateBegin: this.dateTimestamp(flattenedArray[0]),
          pyxisDateEnd: this.dateTimestamp(flattenedArray[1])
        }

        this.setPyxisDateSelected(dates)
      }

      if (this.disponibilityDates.length) {
        const flattenedArray = [].concat(...this.disponibilityDates)
        const dates = {
          availabilityDateBegin: this.dateTimestamp(flattenedArray[0]),
          availabilityDateEnd: this.dateTimestamp(flattenedArray[1])
        }

        this.setDisponibilityDateSelected(dates)
      }

      this._getOrders()
    },
    activeFilterOrderPyxis () {
      if (this.orderPyxisDates.length) {
        this.hasOpenFilterDisponibility = true
        this.$eventBus.$emit('openFilter')
      }
    },
    activeFilterDisponibility () {
      if (this.disponibilityDates.length) {
        this.hasOpenFilterOrderPyxis = true
        this.$eventBus.$emit('openFilter')
      }
    },
    disableBothFilters (flag) {
      this.hasOpenFilterDisponibility = !!flag
      this.hasOpenFilterOrderPyxis = !!flag
    },
    doMovStatesFilterCLicked (movStateOption) {
      this.setMovStatesSelected(movStateOption)
    },
    cleanFilters () {
      this.orderPyxisDates = []
      this.disponibilityDates = []
      this.hasOpenFilterOrderPyxis = false
      this.hasOpenFilterDisponibility = false

      this.$store.dispatch('filters/flush')
      this.$store.dispatch('orders/flush')
      this.$eventBus.$emit('cleanFilters')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/filters/OrderFilters.vue